import { Component, OnInit } from '@angular/core';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';

@Component({
  selector: 'app-three-sixty-review-popup',
  templateUrl: './three-sixty-review-popup.component.html',
  styleUrls: ['./three-sixty-review-popup.component.scss'],
})
export class ThreeSixtyReviewPopupComponent  implements OnInit {
  buttonColorName: any;
  showInfoPopup: any = false
  infoListData: any[] = [
    { info: 'All questions are mandatory.' },
    { info: 'All questions carefully before answering.' },
    { info: 'For open-ended questions, write your response in the space provided.' },
    { info: 'Your responses are confidential and will only be used for research purposes.' }
  ];

  constructor(private pdfDownload:DownloadAsPdfService) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');

  }

  toggleInfoPopup() {
    this.showInfoPopup = !this.showInfoPopup;
  }
}
